module.exports = __webpack_public_path__ + "img/6a6b08b.jpg";